/** @flow */
import constants from './constants';


const config = {
  constants,
};

export default config;
